import { combineReducers } from 'redux'
import login from '../../../common/reducers/login'
import language from '../../../common/reducers/language'
import search from './search'
import modal from '../../../common/reducers/modal'
import { reducer as formReducer } from 'redux-form'
import propertyTypes from '../../../common/reducers/classification/property_types'

const rootReducer = combineReducers({
  login,
  language,
  search,
  propertyTypes,
  modal,
  form: formReducer
})
export default rootReducer
